<template>
    <div id="rummy-home" class="rummy-bg">
        <div class="rummy-home-top">
            <div
                class="rummy-home-login"
                @click="popLogin()"
                v-if="!$store.state.user.isLogin"
            >
                {{ $t("common.LOGIN") }}
            </div>
            <div
                class="rummy-user-box"
                v-if="$store.state.user.isLogin"
                @click="isShowUserInfo = true"
            >
                <div class="rummy-urer-headbg ico ico-head-bg"></div>
                <div
                    class="rummy-urer-defalut ico"
                    :class="'ico-avatar-' + headId"
                    :style="'transform: scale(0.8);'"
                ></div>

                <div class="rummy-urer-text">
                    {{ $store.state.user.realUser.nickname }}
                </div>
                <!-- <div class="rummy-urer-name">
                    {{ $store.state.user.realUser.id }}
                </div> -->
            </div>
            <div
                class="ico ico-cash-bg rummy-home-coin-bg"
                :class="{
                    ' animated fadeOutUp': isDemo,
                    ' animated fadeInDown': !isDemo,
                }"
            >
                <div class="ico ico-icon-coin float-left"></div>
                <div class="home-money float-left">{{ money }}</div>
            </div>
            <!-- <div
                class="rummy-home-coin-bg"
                style="width: 2.91rem"
                v-if="isDemo"
            ></div> -->
            <div
                class="ico ico-btn-deposit my-btn"
                :style="'margin-left: 0.11rem;'"
                @click="toDeposit()"
                v-if="isShowDeposit()"
            ></div>

            <div
                class="ico ico-btn-withdraw my-btn"
                :style="'margin-left: 0.2rem;'"
                @click="toWithraw()"
                v-if="isShowDeposit()"
            ></div>
            <div
                :style="'margin-left: 0.31rem; width:2.27rem'"
                v-if="!isShowDeposit()"
            ></div>
            <div
                v-if="$store.state.user.isLogin"
                class="ico ico-btn-record my-btn"
                :style="'margin-left: 0.63rem;'"
                @click="toBetRecord()"
            ></div>
            <div
                class="ico ico-btn-service my-btn"
                :style="'margin-left: 0.38rem;'"
                @click="isShowCustomerService = true"
            ></div>
            <div
                class="ico ico-btn-setting my-btn"
                :style="'margin-left: 0.38rem;'"
                @click="isShowSetting = true"
            ></div>
        </div>
        <div v-show="isPop" class="rummy-home-mask"></div>
        <div class="rummy-home-game-list" ref="wrapper">
            <div class="rummy-home-game-content" ref="refGameContainer">
                <template v-for="(item, index) in list">
                    <div
                        class="rummy-home-game-icon"
                        :key="index"
                        style="position: relative"
                        @click="toGamePanel(item, index)"
                    >
                        <img :src="item.img" />

                        <div
                            class="corner-mark"
                            :class="{
                                ' animated fadeIn': isDemo,
                                ' animated fadeOut': !isDemo,
                            }"
                        ></div>
                        <div
                            v-show="isPop && popIndex != index"
                            class="game-icon-mask"
                        ></div>
                    </div>
                </template>
            </div>
        </div>
        <div class="rummy-home-footer">
            <div class="rummy-footer-left" v-if="isShowDemobtn">
                <input
                    type="button"
                    class="rummy-home-btn my-btn rummy-home-btn-red"
                    :class="{
                        'rummy-home-btn-s': !isDemo,
                    }"
                    :value="$t('common.Cash')"
                    @click="updateDemoStatus(false)"
                />

                <input
                    type="button"
                    class="rummy-home-btn my-btn rummy-home-btn-grep"
                    :class="{
                        'rummy-home-btn-s': isDemo,
                    }"
                    @click="updateDemoStatus(true)"
                    :value="$t('common.Demo')"
                />
            </div>
            <!-- <img
                src="../../assets/images/show.png"
                class="rummy-footer-right"
            /> -->
        </div>
        <GamePop
            v-show="isPop"
            @on-close="isPop = false"
            @on-helper="isShowRule = true"
            :configKey="configKey"
            :isDemo="isDemo"
        ></GamePop>
        <Login
            @on-close="closeLogin()"
            v-if="isShowLogin"
            @on-register="
                isShowLogin = false;
                isShowRegister = true;
            "
            @on-retrieve="
                isShowLogin = false;
                isShowRetrieve = true;
            "
        >
        </Login>
        <Retrieve @on-close="isShowRetrieve = false" v-if="isShowRetrieve">
        </Retrieve>
        <Register @on-close="isShowRegister = false" v-if="isShowRegister">
        </Register>
        <UserInfo
            @on-close="closeUserInfo()"
            v-if="isShowUserInfo"
            @on-changehead="isShowChangeHead = true"
        ></UserInfo>
        <Setting
            @on-close="isShowSetting = false"
            v-if="isShowSetting"
        ></Setting>
        <CustomerService
            @on-close="isShowCustomerService = false"
            v-if="isShowCustomerService"
        ></CustomerService>
        <ChangeHead
            @on-close="isShowChangeHead = false"
            v-if="isShowChangeHead"
        ></ChangeHead>
        <Help v-show="isShowRule" @on-close="isShowRule = false"></Help>
    </div>
</template>

<script>
import Login from "../login/rummy_login";
import Retrieve from "../login/rummy_retrieve";
import Register from "../login/rummy_register";
import UserInfo from "../user/rummy_user_info";
import Setting from "../user/rummy_setting";
import CustomerService from "../user/rummy_customer_service";
import ChangeHead from "../user/rummy_change_head";
import GamePop from "./game_pop";
import RummyHomeTools from "./rummy_home_tools";
import userfun from "../../utils/userFun";
import tools from "../../utils/fun";
import AnalystManager from "../../utils/analyst";
import ServerManager from "../../interface/server";
import eventConfig from "../../baseConfig/eventConfig";
import dataConfig from "../../baseConfig/dataConfig";
import Help from "../common/rummy-help";
import PaymenetManager from "../../interface/payment";
export default {
    name: "RummyHome",
    components: {
        Login,
        Retrieve,
        Register,
        UserInfo,
        Setting,
        CustomerService,
        ChangeHead,
        GamePop,
        Help,
    },
    data() {
        return {
            isShowLogin: false,
            isShowRetrieve: false,
            isShowRegister: false,
            isShowUserInfo: false,
            isShowSetting: false,
            isShowChangeHead: false,
            isShowCustomerService: false,
            isShowRule: false,
            isLogin: false,
            actAgenter: null,
            list: [],
            listWidth: "0",
            inHandler: null,
            money: "",
            isPop: false,
            popIndex: 0,
            configKey: "",
            popIndex: 0,
            configKey: "",
            isDemo: false,
            isShowDemobtn: true,
        };
    },
    created() {
        this.actAgenter = new RummyHomeTools(this);
        this.money = tools.getMoneyShower(this);
        ServerManager.refreshUser(this);
    },
    mounted() {
        this.initScroll();
        this.setListener();
        this.checkHostParams();
        tools.setLoadingState(false);
        if (dataConfig.isChecking && !this.isTestStatus()) {
            this.isShowDemobtn = false;
            this.$store.commit("temp/setIsDemo", true);
            this.isDemo = true;
        } else {
            //默认真金模式
            this.$store.commit("temp/setIsDemo", this.isDemo);
        }

        //载入live chat
        tools.loadTawk();
        // setTimeout(() => {
        //     const element = document.querySelectorAll(".my-btn");

        //     for (let i = 0; i < element.length; i++) {
        //         let ele = element[i];
        //         if (ele) {
        //             ele.addEventListener("click", (e) => {
        //                 e.currentTarget.classList.add("ele-scale");
        //             });
        //         }
        //     }
        // }, 2000);
    },
    computed: {
        headId() {
            return userfun.getHeadIdByUrl(
                this.$store.state.user.realUser.avatar
            );
        },
    },
    methods: {
        isTestStatus(){
            if (this.$store.state.user.isLogin) {
                let cn = null;
                this.$store.state.user.realUser && (cn = this.$store.state.user.realUser.channel);
                if (cn == "IRAVVFX" || cn == "ICWVVLESS") {
                    return true;
                }
            }
            return false;
        },
        isShowDeposit() {
            //特殊处理
            if (this.isTestStatus()){
                return true;
            }
            //正常渠道处理
            if (dataConfig.isChecking) {
                return false;
            } else {
                if (this.$store.state.user.isLogin) {
                    if (this.$store.state.temp.isBanVisit) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return false;
                }
            }
        },
        updateDemoStatus(status) {
            this.isDemo = status;
            this.$store.commit("temp/setIsDemo", this.isDemo);
        },
        checkHostParams() {
            let data = this.$route.query;
            if (data["action"] == "login") {
                tools.emit(eventConfig.LOGIN_PAGE);
            }
        },
        popLogin() {
            tools.emit(eventConfig.playEffect, "pop");
            this.isShowLogin = true;
            AnalystManager.event(
                this,
                eventConfig.google.home.EVENT,
                eventConfig.google.home.LOGIN
            );
        },
        closeUserInfo() {
            this.isShowUserInfo = false;
            this.money = tools.getMoneyShower(this);
        },
        closeLogin() {
            this.isShowLogin = false;
            this.money = tools.getMoneyShower(this);
        },
        setListener() {
            //事件监听
            tools.on(eventConfig.LOGIN_PAGE, () => {
                tools.setLoadingState(false);
                this.$store.commit("user/clearLogin");
                this.isShowLogin = true;
            });
            tools.on(eventConfig.REFRESH_MONEY, () => {
                this.money = tools.getMoneyShower(this);
            });
            tools.on(eventConfig.autoSetVerifyCode, (info) => {
                if (!this.isShowRegister) {
                    this.isShowRegister = true;
                }
                setTimeout(() => {
                    tools.emit(eventConfig.autoSetCode, info);
                }, 1000);
            });
        },
        clearInHandler() {
            if (this.inHandler) {
                clearInterval(this.inHandler);
            }
            this.inHandler = null;
        },
        initScroll() {
            this.clearInHandler();
            this.inHandler = setInterval(() => {
                if (this.$refs.wrapper) {
                    this.clearInHandler();
                    this.actAgenter.initGameListScroll();
                    this.list = this.actAgenter.getGameList();
                    this.actAgenter.resetScroll(this.list.length);
                }
            }, 50);
        },
        toDeposit() {
            tools.emit(eventConfig.playEffect, "pop");
            tools.toPage(this, { path: "/deposit" });
        },
        toWithraw() {
            tools.emit(eventConfig.playEffect, "pop");
            tools.toPage(this, { path: "/withdraw" });
        },
        toBetRecord() {
            AnalystManager.event(
                this,
                eventConfig.google.home.EVENT,
                eventConfig.google.home.BET_RECORD
            );
            tools.emit(eventConfig.playEffect, "pop");
            tools.toPage(this, { path: "/bet/record" });
        },
        toGamePanel(item, index) {
            if (!item.key) {
                return;
            }
            this.configKey = item.key;
            this.popIndex = index;
            this.isPop = true;
            //事件上报
            AnalystManager.event(
                this,
                eventConfig.google.home.EVENT,
                eventConfig.google.home.actionRoomStart(this.isDemo),
                this.configKey
            );
        },
    },
    destroyed() {
        tools.off(eventConfig.LOGIN_PAGE);
        tools.off(eventConfig.REFRESH_MONEY);
        tools.off(eventConfig.autoSetVerifyCode);
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.rummy-home-top {
    width: 1334px;
    height: 88px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: #080808;
}
.ele-scale:click::before {
    transform: scale(1);
}
.ele-scale:click::after {
    transform: scale(1.2);
}
.rummy-home-login {
    width: 171px;
    height: 55px;
    background: #f82e49;
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.35);
    border-radius: 9px;

    font-size: 27px;
    font-family: Arial;
    font-weight: bold;
    color: #ffffff;

    line-height: 55px;
    text-align: center;
    margin-left: 88px;
    margin-right: 100px;
}
.rummy-home-coin-bg {
    margin-left: 10px;
}
.rummy-home-game-list {
    position: absolute;
    left: 75px;
    top: 110px;
    width: 1184px;
    height: 450px;
    overflow: hidden;
    z-index: 3;
}

.rummy-home-mask {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 2;
    background: rgba(0, 0, 0, 0.35);
}

.rummy-home-game-list .rummy-home-game-content {
    height: 450px;
    width: 1124px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.rummy-home-game-icon {
    position: relative;
    width: 281px;
    height: 400px;
    background-image: url(../../assets/images/default.jpg);
    background-size: 281px 400px;
    border-radius: 30px;
    border: 0;
    margin: 0px 20px 0px 0px;
}

.game-icon-mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.65);
}

.rummy-user-box {
    position: relative;
    height: 88px;
    width: 300px;
    margin-left: 82px;
}
.rummy-urer-headbg {
    position: absolute;
    top: 2px;
}
.rummy-urer-defalut {
    position: absolute;
    top: -3px;
    left: -6px;
}
.rummy-urer-text {
    position: absolute;
    top: 31px;
    left: 90px;

    font-size: 22px;
    font-family: Arial;
    font-weight: 400;
    color: #f82e49;
}
.rummy-urer-name {
    position: absolute;
    top: 51px;
    left: 90px;

    font-size: 22px;
    font-family: Arial;
    font-weight: 400;
    color: #d4d4d4;
}

.home-money {
    color: #ffffff;
    margin-left: 10px;
    width: 212px;
    height: 63px;
    line-height: 63px;
    text-align: center;
    font-size: 28px;
}

.rummy-home-game-icon img {
    width: 281px;
    height: 400px;
    border-radius: 30px;
    border: 0;
}
.rummy-home-game-icon .corner-mark {
    position: absolute;
    left: 0;
    top: 0;
    width: 130px;
    height: 130px;
    background: url(../../assets/images/da-free.png) no-repeat;
    background-size: cover;
}
.rummy-home-footer {
    position: absolute;
    left: 0;
    top: 5.7rem;
    margin-top: 15px;
    width: 1334px;
    height: 110px;
}

.rummy-home-footer .rummy-footer-left {
    float: left;
    margin-left: 105px;
    height: 110px;
}

.rummy-home-btn {
    float: left;
    margin-left: 10px;
    margin-top: 60px;
    width: 128px;
    height: 47px;
    border-radius: 9px;
    border: 0;
    outline: none;
}

.rummy-home-btn-red {
    background-color: #f82838;
    color: #ffffff;
}
.rummy-home-btn-grep {
    color: #ffffff;
    background-color: #3647e7;
}
.rummy-home-btn-s {
    border: 3px solid #fff;
}
.rummy-home-footer .rummy-footer-right {
    float: right;
    width: 440px;
    height: 110px;
    margin-right: 160px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/rummy_home.vue